<template>
  <div class="approval-checklist-detail-index details-view">
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'190px'}"
      style="min-height: 100%"
    >
      <template slot="left">
        <!-- Left menu -->
        <div class="app-main-content">
          <div class="grid-view">
            <div style="display:flex;flex-direction: row; flex: 1;">
              <!--              <ul class="custom-category-list section">-->
              <!--                <li :class="[activeMenu==='1'?'active':'']" @click="handleSelect('1')">{{ $t('CargoMsg.Cargo_IInitiated') }}</li>-->
              <!--                <li :class="[activeMenu==='2'?'active':'']" @click="handleSelect('2')">{{ $t('CargoMsg.Cargo_IDealWithIt') }}</li>-->
              <!--              </ul>-->
              <!-- 【我发起的】 -->
              <el-tree
                style="width: 180px"
                highlight-current
                class="custom-category-list section"
                node-key="id"
                :data="leftData"
                :current-node-key="currentNodeKey"
                @node-click="handleSelect"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="right">
        <div class="app-main-content">
          <div class="tabs-container">
            <!-- Right tabs -->
            <el-tabs v-if="activeMenu === '1'" v-model="lookActiveTab" style="width: 100%" type="card" @tab-click="handleClick">
              <el-tab-pane name="lookAll">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_All') }}
                </span>
                <approval-checklist-detail
                  v-if="lookActiveTab === 'lookAll'"
                  :key="detailRefreshId"
                  ref="lookAll"
                  :status="-1"
                  type="look"
                  config-module="23030701"
                  :show-initiate-btn="true"
                  :view-source="VIEW_SOURCE_INITIATE_ALL"
                  :document-config-id="documentConfigId"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane
                name="lookProcessing"
              >
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Processing') }}
                  <el-badge v-if="initiated.processingCount > 0" :value="initiated.processingCount" />
                </span>
                <approval-checklist-detail
                  v-if="lookActiveTab === 'lookProcessing'"
                  :key="detailRefreshId"
                  ref="lookProcessing"
                  :status="0"
                  type="look"
                  config-module="23030702"
                  :view-source="VIEW_SOURCE_INITIATE_PROCESSING"
                  :document-config-id="documentConfigId"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane
                name="lookCompleted"
              >
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Completed1') }}
                  <!--                  CARGO-34424 【BPM】审批事项清单页签统计数字优化（去掉【已完成、已撤销】上的数字）-->
                  <!--                  <el-badge v-if="initiated.completedCount > 0" :value="initiated.completedCount" />-->
                </span>
                <approval-checklist-detail
                  v-if="lookActiveTab === 'lookCompleted'"
                  :key="detailRefreshId"
                  ref="lookCompleted"
                  type="look"
                  :status="1"
                  config-module="23030703"
                  :show-print-btn="true"
                  :view-source="VIEW_SOURCE_INITIATE_COMPLETED"
                  :document-config-id="documentConfigId"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane
                name="lookRevoked"
              >
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Revoked') }}
                  <!--                  CARGO-34424 【BPM】审批事项清单页签统计数字优化（去掉【已完成、已撤销】上的数字）-->
                  <!--                  <el-badge v-if="initiated.undoCount > 0" :value="initiated.undoCount" />-->
                </span>
                <approval-checklist-detail
                  v-if="lookActiveTab === 'lookRevoked'"
                  :key="detailRefreshId"
                  ref="lookRevoked"
                  :status="2"
                  type="look"
                  config-module="23030704"
                  :view-source="VIEW_SOURCE_INITIATE_REVOKED"
                  :document-config-id="documentConfigId"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
            </el-tabs>
            <el-tabs v-else v-model="approveActiveTab" type="card" @tab-click="handleClick">
              <el-tab-pane name="approveAll">
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_All') }}
                </span>
                <approval-checklist-detail
                  v-if="approveActiveTab === 'approveAll'"
                  :key="detailRefreshId"
                  ref="approveAll"
                  type="approve"
                  :status="-1"
                  config-module="23030705"
                  :show-print-btn="true"
                  :query-all="true"
                  :view-source="VIEW_SOURCE_HANDLE_ALL"
                  :document-config-id="documentConfigId"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane
                name="approvePending"
              >
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Pending') }}
                  <el-badge v-if="approve.processingCount > 0" :value="approve.processingCount" />
                </span>
                <approval-checklist-detail
                  v-if="approveActiveTab === 'approvePending'"
                  :key="detailRefreshId"
                  ref="approvePending"
                  type="approve"
                  :status="0"
                  config-module="23030706"
                  :view-source="VIEW_SOURCE_HANDLE_TODO"
                  :document-config-id="documentConfigId"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
              <el-tab-pane
                name="approveCompleted"
              >
                <span slot="label">
                  {{ $t('CargoMsg.Cargo_Completed1') }}
                  <!--                  CARGO-34424 【BPM】审批事项清单页签统计数字优化（去掉【已完成、已撤销】上的数字）-->
                  <!--                  <el-badge v-if="approve.completedCount > 0" :value="approve.completedCount" />-->
                </span>
                <approval-checklist-detail
                  v-if="approveActiveTab === 'approveCompleted'"
                  :key="detailRefreshId"
                  ref="approveCompleted"
                  type="approve"
                  :status="1"
                  config-module="23030707"
                  :view-source="VIEW_SOURCE_HANDLE_COMPLETED"
                  :document-config-id="documentConfigId"
                  @reloadCount="reloadCount"
                />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </template>
    </cargo-left-right-resize>
  </div>
</template>

<script>
import ApprovalChecklistDetail from '@/views/cargo/v0/ApprovalMatters/ApprovalChecklist/components/detail'
import CargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import {
  BILL_PAYMENT,
  CHARGE_CHANGE,
  COLLECT_INVOICE, CONTRACT_APPLICATION_FORM,
  Job_CHARGE,
  MAKE_INVOICE, PARTNER_APPLICATION_FORM,
  TEMP_CREDIT
} from '@/class/cargo/model/parameters/WorkflowConstants'

export default {
  name: 'ApprovalChecklist',
  components: { CargoLeftRightResize, ApprovalChecklistDetail },
  data() {
    return {
      activeMenu: '1',
      lookActiveTab: 'lookProcessing',
      approveActiveTab: 'approveAll',
      initiated: {
        processingCount: 0,
        completedCount: 0,
        undoCount: 0
      },
      approve: {
        processingCount: 0,
        completedCount: 0,
        undoCount: 0
      },
      VIEW_SOURCE_INITIATE_ALL: WorkflowConstants.VIEW_SOURCE_INITIATE_ALL.code,
      VIEW_SOURCE_INITIATE_PROCESSING: WorkflowConstants.VIEW_SOURCE_INITIATE_PROCESSING.code,
      VIEW_SOURCE_INITIATE_COMPLETED: WorkflowConstants.VIEW_SOURCE_INITIATE_COMPLETED.code,
      VIEW_SOURCE_INITIATE_REVOKED: WorkflowConstants.VIEW_SOURCE_INITIATE_REVOKED.code,
      VIEW_SOURCE_HANDLE_ALL: WorkflowConstants.VIEW_SOURCE_HANDLE_ALL.code,
      VIEW_SOURCE_HANDLE_TODO: WorkflowConstants.VIEW_SOURCE_HANDLE_TODO.code,
      VIEW_SOURCE_HANDLE_COMPLETED: WorkflowConstants.VIEW_SOURCE_HANDLE_COMPLETED.code,
      leftData: [{
        id: 1,
        code: 0, // code对应documentConfigId，0表示没有
        label: this.$t('CargoMsg.Cargo_IInitiated'),
        activeMenu: '1',
        children: [{
          id: 11,
          code: BILL_PAYMENT.code,
          label: this.$t('CargoMsg.Cargo_BillPayment'),
          activeMenu: '1'
        }, {
          id: 12,
          code: MAKE_INVOICE.code,
          label: this.$t('CargoMsg.Cargo_MakeInvoice'),
          activeMenu: '1'
        }, {
          id: 13,
          code: Job_CHARGE.code,
          label: this.$t('CargoMsg.Cargo_JobCharge'),
          activeMenu: '1'
        }, {
          id: 14,
          code: TEMP_CREDIT.code,
          label: this.$t('CargoMsg.Cargo_TempCreditApply'),
          activeMenu: '1'
        }, {
          id: 15,
          code: CHARGE_CHANGE.code,
          label: this.$t('CargoMsg.Cargo_ChargeChangeApply'),
          activeMenu: '1'
        }, {
          id: 16,
          code: COLLECT_INVOICE.code,
          label: this.$t('CargoMsg.Cargo_CollectInvoiceApply'),
          activeMenu: '1'
        }, {
          id: 17,
          code: PARTNER_APPLICATION_FORM.code,
          label: this.$t('CargoMsg.Cargo_PartnerApplicationForm'),
          activeMenu: '1'
        }, {
          id: 18,
          code: CONTRACT_APPLICATION_FORM.code,
          label: this.$t('CargoMsg.Cargo_ContractApplicationForm'),
          activeMenu: '1'
        }]
      }, {
        id: 2,
        code: 0, // documentConfigId
        label: this.$t('CargoMsg.Cargo_IDealWithIt'),
        activeMenu: '2',
        children: [{
          id: 21,
          code: BILL_PAYMENT.code,
          label: this.$t('CargoMsg.Cargo_BillPayment'),
          activeMenu: '2'
        }, {
          id: 22,
          code: MAKE_INVOICE.code,
          label: this.$t('CargoMsg.Cargo_MakeInvoice'),
          activeMenu: '2'
        }, {
          id: 23,
          code: Job_CHARGE.code,
          label: this.$t('CargoMsg.Cargo_JobCharge'),
          activeMenu: '2'
        }, {
          id: 24,
          code: TEMP_CREDIT.code,
          label: this.$t('CargoMsg.Cargo_TempCreditApply'),
          activeMenu: '2'
        }, {
          id: 25,
          code: CHARGE_CHANGE.code,
          label: this.$t('CargoMsg.Cargo_ChargeChangeApply'),
          activeMenu: '2'
        }, {
          id: 26,
          code: COLLECT_INVOICE.code,
          label: this.$t('CargoMsg.Cargo_CollectInvoiceApply'),
          activeMenu: '2'
        }, {
          id: 27,
          code: PARTNER_APPLICATION_FORM.code,
          label: this.$t('CargoMsg.Cargo_PartnerApplicationForm'),
          activeMenu: '2'
        }, {
          id: 28,
          code: CONTRACT_APPLICATION_FORM.code,
          label: this.$t('CargoMsg.Cargo_ContractApplicationForm'),
          activeMenu: '2'
        }]
      }],
      currentNodeKey: 1, // 默认选中第一个节点【我发起的】，对应上面 id：1
      documentConfigId: 0, // 模板类型
      detailRefreshId: 0 // 用于切换单据类型时，重新生成detail组件
    }
  },
  activated() {
    this.handleRouteChange()
  },
  created() {
    if (this.$route.query.documentProcessNo) {
      this.activeMenu = '2'
      this.approveActiveTab = 'approveAll'
    } else {
      const currentNodeKey = sessionStorage.getItem('currentNodeKey')
      if (currentNodeKey) {
        this.currentNodeKey = Number(currentNodeKey)
        this.activeMenu = String(currentNodeKey)
      }
      this.changeTab(this.$route.query.documentProcessNo)
    }
  },
  methods: {
    handleRouteChange() {
      const toPath = this.$route.path
      this.$store.commit('APPROVE_DIALOG_SHOW', '')
      if (toPath === '/ApprovalMatters/ApprovalChecklist' || toPath === '/dashboard') {
        const div = document.getElementById('BillPaymentWorkFlowApplyDialog')
        if (div) {
          this.$store.commit('APPROVE_DIALOG_SHOW', true)
        } else {
          this.$store.commit('APPROVE_DIALOG_SHOW', false)
        }
      }
    },
    handleSelect(data) {
      ++this.detailRefreshId
      this.documentConfigId = data.code
      this.activeMenu = data.activeMenu
      this.$nextTick(() => {
        if (this.activeMenu === '1') {
          this.lookActiveTab = 'lookProcessing'
          sessionStorage.setItem('currentNodeKey', 1)
        }
        if (this.activeMenu === '2') {
          this.approveActiveTab = 'approvePending'
          sessionStorage.setItem('currentNodeKey', 2)
        }
        this.changeTab()
      })
    },
    handleClick() {
      this.changeTab()
    },
    changeTab(documentProcessNo = '') {
      if (this.activeMenu === '1') {
        this.$nextTick(() => {
          this.$refs[this.lookActiveTab].init(documentProcessNo)
          // this.reloadCount()
        })
      }
      if (this.activeMenu === '2') {
        this.$nextTick(() => {
          this.$refs[this.approveActiveTab].init(documentProcessNo)
          // this.reloadCount()
        })
      }
    },
    reloadCount(total) {
      if (this.activeMenu === '1' && this.lookActiveTab === 'lookProcessing') {
        // 处理中的数量
        this.initiated.processingCount = total
      } else if (this.activeMenu === '2' && this.approveActiveTab === 'approvePending') {
        // 处理中的数量
        this.approve.processingCount = total
      }
      // manageCount({ type: this.activeMenu === '1' ? 0 : 1 }).then(res => {
      //   if (this.activeMenu === '1') {
      //     // 处理中的数量
      //     // 已完成的数量
      //     // 已取消的数量
      //     this.initiated.processingCount = res.data.processingCount
      //     this.initiated.completedCount = res.data.completedCount
      //     this.initiated.undoCount = res.data.undoCount
      //   }
      //   if (this.activeMenu === '2') {
      //     // 处理中的数量
      //     // 已完成的数量
      //     // 已取消的数量
      //     this.approve.processingCount = res.data.processingCount
      //     this.approve.completedCount = res.data.completedCount
      //     this.approve.undoCount = res.data.undoCount
      //   }
      // })
    }
  }
}
</script>

<style lang="scss">
  .approval-checklist-detail-index{
    height: 100%;
    margin: 10px;
    .el-tabs{
      width: 100%;
    }
    .app-main-content{
      height: 100%;
    }
    .el-menu-item.is-active {
      background-color: #178def;
    }
    .el-menu{
      height: 35px;
    }
    .el-menu-item{
      height: 35px;
      display: flex;
      align-items: center;
      border:1px solid #d9d9d9;
    }
    .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
        background-color: #009fd6;
        color:#fff;
      }
  }
</style>
